namespace RedBullMOBILE360.CVM {
    export interface CvmSegmentRow {
        Id?: number;
        Title?: string;
        OfferId?: string;
        IsEnabled?: number;
        CampaignId?: number;
        ActionType?: string;
        Criteria?: number[];
    }

    export namespace CvmSegmentRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Title';
        export const localTextPrefix = 'CVM.CvmSegment';
        export const deletePermission = 'CVM:CvmSegment';
        export const insertPermission = 'CVM:CvmSegment';
        export const readPermission = 'CVM:CvmSegment';
        export const updatePermission = 'CVM:CvmSegment';

        export declare const enum Fields {
            Id = "Id",
            Title = "Title",
            OfferId = "OfferId",
            IsEnabled = "IsEnabled",
            CampaignId = "CampaignId",
            ActionType = "ActionType",
            Criteria = "Criteria"
        }
    }
}
